export default {
  sortStrings(firstString: string, secondString: string): number {
    return new Intl.Collator().compare(firstString, secondString);
  }
};
